var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45635 0.880127H5.47753C3.02772 0.880127 1.4917 2.61452 1.4917 5.06991V11.6936C1.4917 14.149 3.02054 15.8834 5.47753 15.8834H12.5075C14.9653 15.8834 16.4941 14.149 16.4941 11.6936V8.48452",
    stroke: "#130F26",
    strokeWidth: 1.19503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33286 7.35847L12.2865 1.40481C13.0282 0.663891 14.2304 0.663891 14.9722 1.40481L15.9417 2.37438C16.6834 3.1161 16.6834 4.3191 15.9417 5.06002L9.95939 11.0424C9.63514 11.3666 9.19536 11.549 8.73647 11.549H5.75208L5.82696 8.53757C5.83812 8.09461 6.01897 7.67236 6.33286 7.35847Z",
    stroke: "#130F26",
    strokeWidth: 1.19503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3818 2.32495L15.0195 5.96263",
    stroke: "#130F26",
    strokeWidth: 1.19503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/EditSquare.4ed6021de6ca1e5eed55fcddb4a3aa28.svg";
export { ForwardRef as ReactComponent };